'use strict';

/* jshint -W098 */
angular.module('mean.databases').controller('DatabasesTimesController', ['$scope', 'Global', 'MeanUser', 'userService', 'builderService', 'ngDialog', 'toaster', '$filter', 'Hours', 'aceUtils', 'timeService', 'myCoordinates', 'Timecards', 'ProjectHours',
  function($scope, Global, MeanUser, userService, builderService, ngDialog, toaster, $filter, Hours, aceUtils, timeService, myCoordinates, Timecards, ProjectHours) {
    $scope.global = Global;
    $scope.package = {
      name: 'contacts'
    };

    $scope.sortType = ['user.username', 'date'];
    $scope.sortReverse = false;
    $scope.itemDetails = {};
    $scope.available_hours = [];

    $scope.user = MeanUser.user;

    var company = userService.getCompanyCode($scope.user.username);
    var trade_code = userService.getTradeCode($scope.user.username);

    userService.getUsers($scope.user.trade[0], company).then(function(result) {
        $scope.users = result;
    });

    userService.getMainAccount($scope.user.username).then(function(main_account) {
        $scope.main_account = main_account;
    });

    $scope.typical = null;

    timeService.getStandardHours($scope.user.trade[0], 
        $scope.user.contractor_code).then(function(typical) {
        $scope.typical = typical;
    });

    $scope.editTimeDetails = function(item) {
        $scope.itemDetails = item;
    };

    $scope.$on('timesLoadEvent', function (event, data) {
        console.log('time load event');
        console.log(data);
        $scope.times = [];
        //var start_date = data.searchProp.start.clone();
        var end_date = moment(data.searchProp.end).startOf('day');
        var curr_date = moment(data.searchProp.start).startOf('day');

        if(data.searchProp.employee === 'All') {
            Timecards.query({
                'trade_code': userService.getTradeCode($scope.user.username),
                'company_code': $scope.user.contractor_code,
                'type': 'DatabaseAllDateRange',
                'start_date': data.searchProp.start,
                'end_date': data.searchProp.end }, function(returned) {

                $scope.times = returned;
                //$scope.buildEmptyTimecards(data);
            });
        } else {
            var user = $filter('filter')($scope.users, {'username': data.searchProp.employee}, true);

            if(user.length !== 1) {
                toaster.pop('error', 'User Error', 'Not able to find selected user.  Contact Admin');
            }

            Timecards.query({
                'trade_code': userService.getTradeCode($scope.user.username),
                'company_code': $scope.user.contractor_code,
                'start_date': data.searchProp.start,
                'end_date': data.searchProp.end,
                'type': 'DatabaseUserDateRange',
                'user': user[0]._id }, function(returned) {

                $scope.times = returned;
                //$scope.buildEmptyTimecards(data);
            });
        }
    });

    $scope.buildEmptyTimecards = function(data) {
        ProjectHours.query({
            'trade': $scope.user.trade[0],
            'all_data': true,
            'company_code': $scope.user.contractor_code,
            'project_id': data.searchProp.project_id,
            'start': data.searchProp.start,
            'end': data.searchProp.end,
            'lot': data.searchProp.lot,
            'phase': data.searchProp.phase,
            'username': data.searchProp.employee,
            'main_username': $scope.main_account.username,
            'populate': true}, function(projectHours) {

            var users = $filter('unique')(projectHours, 'username');

            _.each(users, function(user) {
                //var inlist = $filter('filter')($scope.times, {'username': user.username}, true);
                var found = false;
                for(var i=0; i<$scope.times.length; i++) {
                    if($scope.times[0].user.username === user.username) {
                        found = true;
                        break;
                    }
                }

                if(!found) {
                    var user_info = $filter('filter')($scope.users, {'username': user.username}, true);

                    //build a timecard
                    var hours = $filter('filter')(projectHours, {'username': user.username}, true);
                    var total_hours = 0;
                    _.each(hours, function(hour) {
                        hour.date = moment(hour.date);
                        total_hours += hour.hours;
                    });

                    $scope.times.push({
                        user: user_info[0],
                        trade_code: userService.getTradeCode($scope.user.username),
                        company_code: $scope.user.contractor_code,
                        start_date: moment(data.searchProp.start),
                        end_date: moment(data.searchProp.end),
                        hours: hours,
                        signed: false,
                        fabricated: true,
                        total: {
                            hours: total_hours,
                            overtime_hours: 0,
                            double_hours: 0,
                            production_bonus: 0,
                            effective_rate: 0,
                            extra_break_money: 0,
                            premium_overtime: 0,
                        }
                    });
                }
            });
        });
    };

    $scope.createTimeOperation = function () {
        $scope.returnedOptions = {
            user: $scope.$parent.selectedEmployee,
            hours: {
                clock_in: {
                    time: moment($scope.typical.clock_in)
                },
                lunch_start: {
                    time: moment($scope.typical.lunch_start)
                },
                lunch_end: {
                    time: moment($scope.typical.lunch_end)
                },
                clock_out: {
                    time: moment($scope.typical.clock_out)
                }
            },
            date: moment()
        };

        ngDialog.openConfirm({
            template: 'databases/views/tmpl/databases-new-time.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            
            var start = new Date($scope.returnedOptions.date)
            start.setHours(0);
            start.setMinutes(0);
            start.setSeconds(0);
            var end = new Date($scope.returnedOptions.date)
            end.setHours(23);
            end.setMinutes(59);
            end.setSeconds(59);

            Hours.query({ 'trade_code': userService.getTradeCode($scope.user.username),
                'company_code': $scope.user.contractor_code,
                'type': 'UserDateRange',
                'start': start,
                'end': end,
                'user': $scope.returnedOptions.user._id }, function(timesdb) {
                if(timesdb.length !== 0) {
                    toaster.pop('error', 'Time Create Error', 'User already has an entry for this day');
                    return;
                }

                myCoordinates.get().then(function(coords) {
                    var hour = new Hours({
                        user: $scope.returnedOptions.user._id,
                        date: new Date($scope.returnedOptions.date),
                        trade_code: trade_code,
                        company_code: company,
                        clock_in: {
                            time: new Date($scope.returnedOptions.hours.clock_in.time),
                            code: 'O',
                            location: {
                                lat: coords.lat,
                                lon: coords.lon
                            },
                            ip: coords.ip
                        },
                        lunch_start: {
                            time: new Date($scope.returnedOptions.hours.lunch_start.time),
                            code: 'O',
                            location: {
                                lat: coords.lat,
                                lon: coords.lon
                            },
                            ip: coords.ip
                        },
                        lunch_end: {
                            time: new Date($scope.returnedOptions.hours.lunch_end.time),
                            code: 'O',
                            location: {
                                lat: coords.lat,
                                lon: coords.lon
                            },
                            ip: coords.ip
                        },
                        clock_out: {
                            time: new Date($scope.returnedOptions.hours.clock_out.time),
                            code: 'O',
                            location: {
                                lat: coords.lat,
                                lon: coords.lon
                            },
                            ip: coords.ip
                        },
                    });

                    hour.$save(function(success) {
                        toaster.pop('success', 'Time Created');
                    }, function(error) {
                        toaster.pop('error', 'Time Not Created', error);
                    });
                });
            });

            
        }, function (value) {
            //Do something
            //$scope.new_extra = false;
            console.log('in the do something section');
        });
    };

    $scope.removeTime = function(item) {
        if(!item._id) {
            toaster.pop('error', 'Not A Time Record', 'This entry is only logged hours.');
            return;
        }

        var logged_hours = item.logged_hours;
        item.$delete(function(success) {
            toaster.pop('success', 'Time DB Updated', 'Removed from database');
            var idx = $scope.times.indexOf(item);
            if(idx === -1) {
                toaster.pop('warning', 'Invoice Not Found', 
                    'Could not determine proper time from list.  Please resubmit query to refresh the list.');
            } else {
                if(logged_hours && logged_hours>0) {
                    success.logged_hours = logged_hours;
                    $scope.times.splice(idx, 1, success);
                } else {
                    $scope.times.splice(idx, 1);
                }
            }
        }, function(error) {
            toaster.pop('error', 'Time DB Error', error);
        });
    };

    $scope.removeTimeOperation = function(item) {
        ngDialog.openConfirm({
            template:
                '<h2>Delete Time Card Data</h2>' +
                '<p>This operation will delete time card data from the system</p>' +
                '<p>Are you sure you want to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.removeTime(item);
        }, function (value) {
            //Do something 
            console.log('in the do something section of removeInvoiceOperation');
        });
    };

    $scope.refreshTimeTotal = function(item) {
        item.total.hours = 0; 

        _.each(item.project_hours, function(hour) {
            item.total.hours += hour.hours;
        });

        item.$update(function(success) {
            item = success;
            toaster.pop('success', 'Time Card Updated');
        }, function(error) {
            toaster.pop('error', 'Time Card Update Error', error);
        });
    };

    $scope.associateHours = function() {
        if($scope.$parent.selectedEmployee.username === 'All') {
            toaster.pop('error', 'Select Employee Error', 
                'Please select an employee to associate hours to this timecard.');
            return;
        }

        var start = moment($scope.$parent.startDate);
        var end = moment($scope.$parent.endDate);

        // var user = $filter('filter')($scope.users, {
        //     'username': $scope.$parent.selectedEmployee.username}, true);

        // if(user.length !== 1) {
        //     toaster.pop('error', 'User Error', 'Not able to find selected user.  Contact Admin');
        // }

        Hours.query({ 'trade_code': userService.getTradeCode($scope.user.username),
            'company_code': $scope.user.contractor_code,
            'type': 'UserDateRange',
            'start': start.toDate(),
            'end': end.toDate(),
            'user': $scope.$parent.selectedEmployee._id }, function(timesdb) {

            $scope.available_hours = timesdb;

            var tidx = $scope.times.findIndex(x => x.user._id === $scope.$parent.selectedEmployee._id);

            if(tidx === -1) {
                toaster.pop('error', 'Timecard Error', 'Timecard not created.');
                return;
            }

            var timecard = $scope.times[tidx];

            _.each($scope.available_hours, function(hour) {
                hour.date = moment(hour.date);
                var idx = timecard.hours.findIndex(x => x._id === hour._id);
                if(idx === -1) {
                    timecard.hours.push(hour);
                }
            });

            timecard.$update(function(success) {
                toaster.pop('success', 'Timecard Updated');
            }, function(error) {
                toaster.pop('error', 'Timecard Update Error', error);
            })
        });
    }

    $scope.associateLabor = function() {
        if($scope.$parent.selectedEmployee.username === 'All') {
            toaster.pop('error', 'Select Employee Error', 
                'Please select an employee to associate hours to this timecard.');
            return;
        }

        var start = moment($scope.$parent.startDate);
        var end = moment($scope.$parent.endDate);

        ProjectHours.query({ 
            'trade': $scope.user.trade[0],
            'company_code': $scope.user.contractor_code,
            'type': 'userDateRange',
            'start': start.toDate(),
            'end': end.toDate(),
            'username': $scope.$parent.selectedEmployee.username }, function(timesdb) {

            $scope.available_hours = timesdb;

            var tidx = $scope.times.findIndex(x => x.user._id === $scope.$parent.selectedEmployee._id);

            if(tidx === -1) {
                toaster.pop('error', 'Timecard Error', 'Timecard not created.');
                return;
            }

            var timecard = $scope.times[tidx];
            timecard.project_hours = []

            _.each($scope.available_hours, function(hour) {
                //hour.date = moment(hour.date);
                var idx = timecard.hours.findIndex(x => x._id === hour._id);
                if(idx === -1) {
                    timecard.project_hours.push(hour);
                }
            });

            timecard.$update(function(success) {
                toaster.pop('success', 'Timecard Updated');
            }, function(error) {
                toaster.pop('error', 'Timecard Update Error', error);
            })
        });
    }
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/databases/public/controllers/database-times.js